import Button from "../../../../components/bootstrap/Button";
import Card, { CardFooterRight, CardTabItem } from "../../../../components/bootstrap/Card";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../../../components/bootstrap/Modal";


interface Props {
    isModalOpened: boolean;
    onModalClose: () => void;
    onAfterSubmit: () => void;
    beforeEvidence?: string;
    afterEvidence?: string;
}

export const WorkOrderDetailModal = ({ isModalOpened, onModalClose, onAfterSubmit, beforeEvidence,  afterEvidence}: Props) => {

    const onClose = () => {
        onModalClose();
    };

    return (
        <Modal isOpen={isModalOpened} setIsOpen={onClose} size={'xl'} isCentered isStaticBackdrop>
            <ModalHeader setIsOpen={onClose}>
                <ModalTitle id='company-modal'>Evidências</ModalTitle>
            </ModalHeader>
            <ModalBody>

                <Card hasTab tabButtonColor='primary'>

                    <CardTabItem id='tab-item-1' title='Imagem de evidência antes' icon='Image'>
                        <div className='row g-4'>
                            <img src={beforeEvidence} alt='antes' width='100%' />
                        </div>
                    </CardTabItem>

                    <CardTabItem id='tab-item-2' title='Imagem de evidência depois' icon='Image'>
                        <div className='row g-4'>
                            <img src={afterEvidence} alt='depois' width='100%' />
                        </div>
                    </CardTabItem>
                </Card>
            </ModalBody>
            <ModalFooter className='bg-transparent'>
                <CardFooterRight>
                    <Button color='primary' className='w-100' onClick={onClose}>
                        Fechar
                    </Button>
                </CardFooterRight>
            </ModalFooter>
        </Modal>
    );
}